export default __webpack_public_path__ + "static/media/payoutDefault.efc1f571.png";